module.exports = __webpack_public_path__ + "static/img/ch2.32a7019.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/クリスマス/ch2.png
// module id = 850
// module chunks = 1